/**
 * @generated SignedSource<<d78054eba3d48cd5642301190ddb3875>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type issuesNewsletterArticleQuery$variables = {
  first: number;
  typeIds: ReadonlyArray<string | null>;
};
export type issuesNewsletterArticleQuery$data = {
  readonly articles: {
    readonly " $fragmentSpreads": FragmentRefs<"issuesDropdownNewsletterArticleArticleConnection">;
  };
};
export type issuesNewsletterArticleQuery = {
  response: issuesNewsletterArticleQuery$data;
  variables: issuesNewsletterArticleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "typeIds"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "typeIds",
        "variableName": "typeIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "DESC",
      "field": "PUBLISHED_DATE"
    }
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "issuesNewsletterArticleQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "issuesDropdownNewsletterArticleArticleConnection"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "issuesNewsletterArticleQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Article",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entityId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entityUuid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publishedDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "urlAlias",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "16fda543e65f5522c6a2f82627dc3dd2",
    "id": null,
    "metadata": {},
    "name": "issuesNewsletterArticleQuery",
    "operationKind": "query",
    "text": "query issuesNewsletterArticleQuery(\n  $typeIds: [String]!\n  $first: Int!\n) {\n  articles(filter: {typeIds: $typeIds}, orderBy: {field: PUBLISHED_DATE, direction: DESC}, first: $first) {\n    ...issuesDropdownNewsletterArticleArticleConnection\n  }\n}\n\nfragment issuesDropdownNewsletterArticleArticleConnection on ArticleConnection {\n  edges {\n    node {\n      entityId\n      entityUuid\n      publishedDate\n      urlAlias\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "456c348458369da26089c38266ecebfc";

export default node;
